import {
  Box,
  Alert,
  Card,
  Container,
  Grid,
  Typography
} from '@mui/material';
import React, { Component } from 'react';
import Snackbar from '@mui/material/Snackbar';
import { Helmet } from 'react-helmet';
import ahcStatus from '../../../../models/ahcStatus';
import AhcMisResults from './AhcMisResults';
import { _axios } from 'src/plugins/axios';
import commonService from 'src/service/common';
import AhcMisToolbar from './AhcMisToolbar';
import moment from 'moment';
import goodalipi from 'src/plugins/goodalipi';

const masterDataCountItems = JSON.parse(JSON.stringify(ahcStatus));

export class AhcMISEmployees extends Component {
  constructor(props) {
    super(props);
    this.state = {
      totalCount: 0,
      dateRange: [],
      goldEmployees: [],
      activeConsultations: [],
      displayEmployees: [],
      selectionData: {
        campLocation: [],
        providerName: [],
        campType: []
      },
      filter: {
        dateRange: [],
        campus: [],
        location: [],
        bene: [],
        entityRequested : '',
        globalHR : goodalipi.get('globalHR') ? goodalipi.get('globalHR') : false,
        statusId : "",
        payment : ''
      },
      filterOptions: {
        campusList: [],
        locationList: [],
        beneList: [],
        entityRequested : goodalipi.get('globalHRgroup') ? goodalipi.get('globalHRgroup') : [],
        statusId : ['Attended' ,'Confirmed','NewAppointment','NotAttended','NotConfirmed'],
        paymentList : []
      },
      loading: {
        sponseredAndPaidCount: false,
        goldEmployees: false,
        activeConsultations: false
      },
      server: {
        sponseredAndPaidCount: true,
        goldEmployees: true,
        activeConsultations: true
      },
      statusCount: masterDataCountItems,
      activeBookingsCount: 0,
      activeTable: 0,
      startIndex: 0,
      pageSize: 5
    };
  }

  setLoadingServer(name, loading, server) {
    this.setState((prev) => ({
      loading: {
        ...prev.loading,
        [name]: loading
      },
      server: {
        ...prev.server,
        [name]: server
      }
    }));
  }

  setFilters(obj) {
    this.setState(
      {
        filter: {
          ...obj,
          campus: [],
          location: [],
          bene: []
        }
      },
      () => {
        this.applyFilters();
      }
    );
  }

  resetFilters() {
    this.setState({
      filter: {
        dateRange: [],
        campus: [],
        location: [],
        bene: []
      }
    });
  }

  fetchFilters() {
    this.setLoadingServer('filter', true, true);
    _axios
      .post(
        'ahc/filters',
        {
          service: 1
        },
        {
          ignoreLoading: true,
          headers: {
            authtoken: commonService.getAuthToken(),
            'Content-Type': 'application/json'
          }
        }
      )
      .then((response) => {
        if (response.data && response.data.isSuccess) {
          let city_map = [];
          _.keys(response.data.CityAndId).forEach((each) => {
            let ob = {};
            ob['key'] = each;
            ob['val'] = response.data.CityAndId[each];
            city_map.push(ob);
          });
          this.setState((prev) => ({
            filterOptions: {
              ...prev.filterOptions,
              locationList: city_map,
              campusList:
                response.data.result && response.data.result.PrimaryName
                  ? response.data.result.PrimaryName
                  : [],
              beneList: response.data.result.relation
            }
          }));
          this.setLoadingServer('filter', false, true);
        } else {
          this.setLoadingServer('filter', false, false);
        }
      })
      .catch((error) => {
        this.setLoadingServer('filter', false, false);
      });
  }

  downloadFile(url) {
    var link = document.createElement('a');
    link.setAttribute('download', '');
    link.href = url;
    document.body.appendChild(link);
    link.click();
    link.remove();
  }
getDownloadReportFlag(){
  return goodalipi.get('user').viewReports ? goodalipi.get('user').viewReports : false
}

  exportFile(filetype){
    console.log(this.state.filter)
    let payload = {
      fileType: filetype
    }
    if (this.state.filter.dateRange.length == 2 && this.state.filter.dateRange[0] && this.state.filter.dateRange[1]) {
      payload.apptDateBegin = moment(this.state.filter.dateRange[0]).format('YYYY-MM-DD')
      payload.apptDateEnd = moment(this.state.filter.dateRange[1]).format('YYYY-MM-DD')
    }
    if (this.state.filter.location.length > 0) {
      payload.location = this.state.filter.location
    }
    if (this.state.filter.campus.length > 0) {
      payload.campus = this.state.filter.campus
    }
    if(this.state.filter.entityRequested){
      payload.globalHR = true,
      payload.entityRequested = this.state.filter.entityRequested
    }
    if(this.state.filter.payment){
      payload.payment = this.state.filter.payment
    }
    if(this.state.filter.bene.length > 0){
      payload.benf = this.state.filter.bene 
    }
    if(this.state.filter.statusId) {
      payload.statusId = this.state.filter.statusId
    }
    this.setState({ 
      loading: false,
      showSnack: true,
      snackMsg: 'File downloaded in progress...',
      snackType: 'info',
    })
    if(this.state.activeTable == 0){
      this.downloadMisData(payload)
    }
  }

  downloadMisData(payload) {
    _axios
      .post(
        'ahc/misData',
        {
          service: 1,
          ...payload
        },
        {
          ignoreLoading: true,
          headers: {
            authtoken: commonService.getAuthToken(),
            'Content-Type': 'application/json'
          }
        }
      )
      .then((response) => {
        if (
          response.data &&
          response.data.isSuccess &&
          response.data.preSignedUrl
        ) {
          this.downloadFile(response.data.preSignedUrl);
          this.setState({
            loading: false,
            showSnack: true,
            snackMsg: 'File downloaded successfully!',
            snackType: 'success'
          });
        } else if (response.data && !response.data.isSuccess) {
          this.setState({
            loading: false,
            showSnack: true,
            snackMsg: 'File downloaded failed!',
            snackType: 'error'
          });
        }
      })
      .catch((error) => {
        this.setState({
          loading: false,
          showSnack: true,
          snackMsg: 'File downloaded failed!',
          snackType: 'error'
        });
      });
  }

  fetchFilters() {
    this.setLoadingServer("filter", true, true);
    _axios.post('ahc/filters', {
      "service": 1
    }, {
      ignoreLoading: true,
      headers: {
        authtoken: commonService.getAuthToken(),
        'Content-Type': 'application/json'
      }
    }).then((response) => {
      if (response.data && response.data.isSuccess) {
        console.log("line 294",   response.data.CityAndId);
        let city_map = [];
        _.keys(response.data.cityAndId).forEach((each) => {
          let ob = {};
          ob["key"] = each;
          ob["val"] = response.data.cityAndId[each];
          city_map.push(ob);
        })
        this.setState((prev) => ({
          filterOptions: {
            ...prev.filterOptions,
            locationList: city_map,
            campusList: (response.data.result && response.data.result.PrimaryName) ? response.data.result.PrimaryName : [],
            beneList: response.data && response.data.result && response.data.result.relation ?  response.data.result.relation : [],
            paymentList : response.data && response.data.result && response.data.result.PaymentSource ? response.data.result.PaymentSource : [] 
          },
        }))
        this.setLoadingServer("filter", false, true);
      } else {
        this.setLoadingServer("filter", false, false);
      }
    }).catch((error) => {
      this.setLoadingServer("filter", false, false);
    })
  }

  setActiveTable(tab) {
    if (tab == this.state.activeTable) {
      return;
    }
    this.setState(
      {
        activeTable: tab,
        displayEmployees: [],
        startIndex: 0,
        pageSize: 5
      },
      () => {
        if (tab === 0) {
          this.fetchGoldEmployees();
        }
      }
    );
  }

  fetchMisData(obj = {}) {
    let payLoad = {};
    // payLoad["service"] = 1
    payLoad['startIndex'] = this.state.startIndex;
    payLoad['pageSize'] = this.state.pageSize;
    if(this.state.filter.dateRange[0]){
      payLoad.apptDateBegin = moment(this.state.filter.dateRange[0]).format(
        'YYYY-MM-DD'
      );
      payLoad.apptDateEnd = moment(this.state.filter.dateRange[1]).format(
        'YYYY-MM-DD'
      );
    }
    Object.keys(obj).map((item) => {
      if (item !== 'dateRange') {
        payLoad[item] = obj[item];
      }
    });
    this.setLoadingServer('fetchMisData', true, true);
    _axios
      .post('ahc/misData', payLoad, {
        ignoreLoading: false,
        headers: {
          authtoken: commonService.getAuthToken(),
          'Content-Type': 'application/json'
        }
      })
      .then((response) => {
        if (response.data && response.data.isSuccess) {
          this.setState(
            {
              displayEmployees: response.data.result
            },
            () => this.setLoadingServer('fetchMisData', false, true)
          );
        } else {
          this.setLoadingServer('activeConsultations', false, false);
        }
      })
      .catch((error) => {
        this.setLoadingServer('activeConsultations', false, false);
      });

      _axios.post('ahc/getAllTypeCount', payLoad, {
        ignoreLoading: true,
        headers: {
          authtoken: commonService.getAuthToken(),
          'Content-type': 'application/json'
          }
        })
        .then((response) => {
          this.setState({ activeBookingsCount: response.data[1] != null ? response.data[1].Total : 900 });
        })
  }

  onFilterChange(type, value, activeTable) {
    
    switch (type) {
      case 'limit':
        this.state.pageSize = value;
        break;
      case 'page':
        this.state.startIndex = value;
        break;
    }
    this.setState({
      filter: {
        ...this.state.filter
      }
   }, () => {
     if(this.state.activeTable == 0){
       this.fetchMisData(this.state.filter);
     }
    })
  }


  applyFilters() {
    const payload = {};
    if (this.state.filter.campus.length)
      payload.provider = this.state.filter.campus;
    if (this.state.filter.location.length)
      payload.cityId = this.state.filter.location;
    if (this.state.filter.bene.length && this.state.activeTable == 0)
      payload.benf = this.state.filter.bene;
    if (this.state.filter.dateRange.length == 2) {
      payload['apptDateBegin'] = moment(this.state.filter.dateRange[0]).format(
        'YYYY-MM-DD'
      );
      payload['apptDateEnd'] = moment(this.state.filter.dateRange[1]).format(
        'YYYY-MM-DD'
      );
    }
    if(this.state.filter.statusId.length && this.state.filter.statusId){
      payload['statusId'] = this.state.filter.statusId;
    }
    if(this.state.filter.payment && this.state.filter.payment.length){
      payload['payment'] = this.state.filter.payment;
    }

    if(this.state.filter.entityRequested) {
      payload['entityRequested'] = this.state.filter.entityRequested;
      payload['globalHR'] = true;
    }

    if (this.state.activeTable == 0) {
      this.fetchMisData(payload);
    }
  }

  componentDidMount() {
    this.fetchMisData();
    this.fetchFilters();
  }
  render() {
    return (
      <>
        <Helmet>
          <title>AHC | MIS Data</title>
        </Helmet>
        <Box
          sx={{
            backgroundColor: 'background.default',
            minHeight: '100%',
            py: 2
          }}
        >
          {' '}
          <Grid
            item
            sx={{
              marginLeft: 3
            }}
          >
           <AhcMisToolbar activeTable={this.state.activeTable} filterOptions={this.state.filterOptions} filter={this.state.filter} setFilters={(value) => this.setState({ filter: value })} onRefresh={() => this.applyFilters()}></AhcMisToolbar>
          </Grid>
          <Container maxWidth={false}>
            <Grid container>
              <Grid item xs={12}>
                <Card
                  sx={{
                    width: '100%',
                    borderRadius: 4,
                    mb: 2,
                    p: 3,
                    boxShadow: '0 0 16px 0 rgba(0, 0, 0, 0.06)'
                  }}
                >
                  <AhcMisResults
                    displayEmployees={this.state.displayEmployees}
                    totalCount={this.state.activeBookingsCount}
                    goldEmployees={this.state.goldEmployees}
                    activeConsultations={this.state.activeConsultations}
                    setActiveTable={(e) => this.setActiveTable(e)}
                    activeTable={this.state.activeTable}
                    loading={this.state.loading}
                    server={this.state.server}
                    DownloadReports={this.getDownloadReportFlag()}
                    exportFile={(filetype) => this.exportFile(filetype)}
                    onPaginationChange={(type, value, activeTable) =>
                      this.onFilterChange(type, value, activeTable)
                     
                    }
                  />
                </Card>
              </Grid>
            </Grid>
          </Container>
          <Snackbar
            open={this.state.showSnack}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            autoHideDuration={4000}
            onClose={() => this.setState({ showSnack: false })}
          >
            <Alert
              onClose={() => this.setState({ showSnack: false })}
              severity={this.state.snackType}
            >
              {this.state.snackMsg}
            </Alert>
          </Snackbar>
        </Box>
      </>
    );
  }
}

export default AhcMISEmployees;
